'use client'

import { getLocalRegister } from '@/lib/actions'
import { useApp, useModals, useUser } from '@/lib/hooks'
import React from 'react'

import { CloseRegister } from '@/components/molecules'
import {
  Badge,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'

interface CloseRegisterModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const CloseRegisterModal = ({ open }: CloseRegisterModalProps) => {
  const [registerId, setRegisterId] = React.useState<any>(0)
  const { closeModal } = useModals()

  const getRegister = React.useCallback(async () => {
    if (!open) return
    const register = await getLocalRegister()
    setRegisterId(register?.id)
  }, [open])

  React.useEffect(() => {
    getRegister()
  }, [getRegister])

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          closeModal('CLOSE_REGISTER')
        }
      }}
    >
      <DialogContent overlayClassName="pointer-events-none" size="md">
        <DialogHeader>
          <DialogTitle>
            <div className="flex items-center gap-2">
              Close Register
              {registerId && (
                <Badge variant="secondary" size="lg">
                  {registerId}
                </Badge>
              )}
            </div>
          </DialogTitle>
          <DialogDescription className="text-left">
            Enter your closing balance to close the register
          </DialogDescription>
        </DialogHeader>
        <div className="flex h-full w-full">
          <CloseRegister open={open} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
